



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CategoryMagazineCount, MagazineFilterValues } from '../../store/storeStateInterfaces';
import { namespace } from 'vuex-class';
import i18n from '@/i18n';

const MagazineStore = namespace('magazine');
const ApplicationStore = namespace('application');

@Component({})
export default class LanguageDialogComponent extends Vue {
    @MagazineStore.Getter('languages')
    public _languages!: string[];

    get languages(): string[] {
        return this._languages;
    }

    @MagazineStore.Action('applyFilterLanguage')
    public applyFilterLanguage!: (language: string[]) => void;

    @MagazineStore.Getter('categoryMagazineCount')
    public categoryMagazineCount?: CategoryMagazineCount;

    @MagazineStore.Getter('filterValues')
    public _filterValues!: MagazineFilterValues;

    @ApplicationStore.Getter('languageDialog')
    public _languageDialog!: boolean;

    @ApplicationStore.Mutation('setLanguageDialog')
    private setLanguageDialog!: (value: boolean) => void;

    get languageDialog(): boolean {
        return this._languageDialog ?? false;
    }

    set languageDialog(value: boolean) {
        this.setLanguageDialog(value);
    }

    /**
     * Datas tructure to handle language in checkboc list
     */
    public languageWrapperList: { name: string, selected: boolean }[] = [];
    public languageWrapperListCache?: boolean[];
    public allLanguageItemWrapper: { name: string, selected: boolean } = {
        name: 'all',
        selected: false
    };

    get filterValues(): MagazineFilterValues {
        return this._filterValues;
    }

    /**
     * Support function to preprocess languages wrapper values
     */
    @Watch('languages')
    public setLanguageDialogWrapperValues() {
        this.allLanguageItemWrapper = {
            name: 'all',
            selected: this.filterValues.languages.includes('all')
        };
        this.languageWrapperList = this.languages!
            .map(language => ({
                    name: language,
                    selected: this.filterValues.languages.includes(language)
                })
            );
    }

    public mounted() {
        this.setLanguageDialogWrapperValues();
    }

    /**
     * Support function to return available magazines for selected language
     */
    public getLanguageMagazineLabel(language: string): string {
        const abbrv = this.$t(`LANGUAGES.ABBRV.${language.toLocaleUpperCase()}`).toString();
        if (this.categoryMagazineCount) {
            const categoryKey = this.filterValues.category ? this.filterValues.category.id : 'total';
            return `${abbrv} (${this.categoryMagazineCount[language]?.[categoryKey] ?? 0})`;
        } else {
            return abbrv;
        }
    }

    /**
     * Event handler for canceling of language selection
     */
    public onLanguageSelectionCancel() {
        // set init value again
        this.setLanguageDialogWrapperValues();
        this.setLanguageDialog(false);
    }

    /**
     * Event handler for language selection
     */
    public onLanguageSelection() {
        const languages = [this.allLanguageItemWrapper, ...this.languageWrapperList]
            .filter(item => item.selected)
            .map(item => item.name);
        this.applyFilterLanguage(languages);
        this.setLanguageDialog(false);
    }

    /**
     * Handles 'all' language change
     * @param value
     */
    public handleOnAllChange() {
        if (this.allLanguageItemWrapper.selected) {
            // cache old selection
            this.languageWrapperListCache = this.languageWrapperList.map(item => item.selected);
            // deselect each selected item
            this.languageWrapperList.forEach(item => {
                item.selected = false;
            });
        } else {
            // if handles edge case
            if (this.languageWrapperListCache) {
                // apply cached selection
                this.languageWrapperListCache
                    .forEach((item, index) => {
                        this.languageWrapperList[index].selected = item;
                    });
            } else {
                // if no cache is available, use default language
                const defaultLang = this.languageWrapperList.find(item => item.name === i18n.locale)!;
                defaultLang.selected = true;
            }
        }
    }

    /**
     * Handles not 'all' language change
     */
    public handleOnLanguageChange() {
        this.allLanguageItemWrapper.selected = false;
        this.languageWrapperListCache = undefined;
    }
}
